import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from './shared/store-management/state/app-state';
import * as receiving from './shared/store-management/actions/receiving-action';
import * as appApiResources from '../shared/globalcontants';
import { APIServiceProviderService } from '../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import moment from 'moment-timezone';

import {
    selectReceivingViewModel,
    selectReceivingSearch,
    selectReceivingSorting,
    selectReceivingPoSearch,
    selectLookupDetailSuccess,
    selectLookupGridDetails,
    selectItemListDetails,
    selectReceivingDetailByidSuccess,
    selectSuplierList,
    selectSuplierSuccess,
    selectLocationList,
    ReceivingSucess,
    ReceivingSavedSuccess,
    ReceivingFormDetailSuccess,
    GetReceivingPoSumary,
    selectSupplierItemNumber
} from './shared/store-management/selectors/receiving.selector';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import {
    ReceivingList,
    SearchModel,
    SortKeyObject,
    ReceivingLoad,
    SearchById,
    LookupModel,
    PoLookupModel,
    PurchaseModel,
    GetReceivingParamsDetaildById,
    PodetailModel,
    SuplierViewList,
    MerchandiseArrivalHeaderDetail,
    UnitsDetails,
    PopupModel,
    PostMerchandiseArrivalHeaderDetail,
    PostMerchandiseArrivalItemDetails,
    PostSavedMA,
    SnackbarMessage,
    ReceivingPostModel   
} from './shared/models/index';
import { map } from 'rxjs/operators';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { UnitTypeId } from './shared/services/configuration';
import { PopupdialogComponent } from './shared/components/pop-up-component/pop-up-dialog.component';
import { ConfigurationService } from './shared/services/configuration.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReceivingSnackbarComponent } from './shared/components/receivingsnackbar/receivingsnackbar.component';
import { SETTINGCONFIG } from './shared/services/configuration';
import { APIENDPOINTURL } from './shared/services/configuration';
import { FacadeService } from './shared/services/facade.service';
import { InventoryLookUpPost, SupplierItemLookUpPost } from '../shared/models/Inventory/InventoryLookUpEntity';
import { UnitEntity } from '../shared/models/Units/UnitsEntity';
import { TranslateService } from '@ngx-translate/core';
import { apiURLs, EntityName } from '../shared/globalcontants';
import { ValidationEntity } from '../shared/models/Utilities/ValidationEntity';
import { SearchHistoryPostEntity } from '../shared/models/Transactions/SearchHistoryEntity';
import { CommonService } from '../shared/services/common.service';
import { GlobalConversionService } from '../shared/services/GlobalMethodService/GlobalConversion-Service';
import { SystemPrefModel } from '../shared/models/Utilities/CommonEntity';
import { HttpRequestService } from '../shared/services/http-request.service';
import { RequestService } from '../shared/services/RequestServices/Request-Service';
@Injectable({
    providedIn: 'root'
})
export class ReceivingBusinessService {
    receivingData: ReceivingList;
    poLookupModel: PoLookupModel[];
    receivingTotalAmount: any;
    totalMiscCharges: any;
    purchaseModel: PurchaseModel[];
    merchandiseArrivalHeaderDetail: MerchandiseArrivalHeaderDetail;
    merchandiseArrivalItemGridDetails: any;
    loginUserName: string;
    supplierlist: Array<any> = [];
    locationList: Array<any> = [];
    headLocationList: Array<any> = [];
    headDepartmentList: Array<any> = [];
    headAccountList: Array<any> = [];
    headPayTermList: Array<any> = [];
    itemsFrom: string;
    actionItem: string;
    isBarcodeScan: boolean;
    PostEnableDisable = new BehaviorSubject<boolean>(false);
    selectReceivingSearchsub: Subscription;
    selectReceivingSortingsub: Subscription;
    selectSupplierSuccesssub: Subscription;
    selectLocationListsub: Subscription;
    selectLookupDetailSuccesssub: Subscription;
    selectReceivingDetailByidSuccesssub: Subscription;
    purchaseModelArray: PurchaseModel[];
    checkQuantityBool: any;
    barcodeAutoIncrement: number;
    soundMode: string;
    barcodeIncreament = 0;
    isPostAndContinue = false;
    inputSearchHistoryEntity: SearchHistoryPostEntity;
    PurchaseOrderDetails = [];
    isLandingNavigation = false;
    duplicateItem = new BehaviorSubject<any>(0);
    poLoadedLookupResponse: any;
    cloneSupplierDropdownList: Array<any> = [];
    selectedSupplierId: any;
    isTaxExemption: boolean = false;
    supplierName: string = '';
    constructor(
        private store: Store<AppState>,
        private route: Router,
        private translateService: TranslateService,
        private apiServiceProviderService: APIServiceProviderService,
        private snackBar: MatSnackBar,
        private facadeService: FacadeService,public _commonService: CommonService,
        private globalservice : GlobalConversionService,
        private activatedRoute: ActivatedRoute,
        private httpService: HttpRequestService
        // private translateService: Translate,
    ) {
        this.selectReceivingSearchsub = this.store.pipe(select(selectReceivingSearch)).subscribe(x =>
            this.store.dispatch(new receiving.GetReceivingViewModel(x))
        );
        this.selectReceivingSortingsub = this.store.pipe(select(selectReceivingSorting)).subscribe(x =>
            this.store.dispatch(new receiving.GetReceivingSorting(x))
        );
        this.selectSupplierSuccesssub = this.store.pipe(select(selectSuplierSuccess)).subscribe(x => {
            this.supplierlist = [];
            if (x && x !== null) {
                if (x && x.hasOwnProperty('value') && x.value.length > 0) {
                    x.value.forEach((element: any) => {
                        const suplierObject = {} as SuplierViewList;
                        suplierObject.SupplierId = element.Id;
                        suplierObject.SupplierName = element.Name;
                        suplierObject.SupplierNumber = element.Name;
                        suplierObject.RNIOptionId = element.RNIOptionId
                        suplierObject.CurrencyId = element.CurrencyId
                        suplierObject.ExchangeRate =  element.ExchangeRate
                        this.supplierlist.push(suplierObject);
                    });
                }
            }
        });
        this.selectLocationListsub = this.store.pipe(select(selectLocationList)).subscribe(x => {
            if (x) {
                this.locationList = [];
                if (x && x.hasOwnProperty('value') && x.value.length > 0) {
                    this.locationList = x.value;
                }

            }
        });
        this.selectLookupDetailSuccesssub = this.store.pipe(select(selectLookupDetailSuccess)).subscribe(x => {
            if (x && x !== null && x !== undefined) {
                let response;
                if (x?.ResultData && Array.isArray(x.ResultData) && x.ResultData.length > 0) {
                    response = x.ResultData[0];
                } else if (x?.ResultData) {
                    response = x.ResultData;
                } else {
                    response = x.value;
                }
                const formData = this.merchandiseArrivalHeaderDetailReassign(response);
                this.poLoadedLookupResponse = formData;
                this.store.dispatch(new receiving.ReceivingformDetails(formData));
            }
        });
        this.selectReceivingDetailByidSuccesssub = this.store.pipe(select(selectReceivingDetailByidSuccess)).subscribe(x => {
            if (x && x !== null && x !== undefined) {
                let response;
                if (x?.ResultData && Array.isArray(x.ResultData) && x.ResultData.length > 0) {
                    response = x.ResultData[0];
                } else if (x?.ResultData) {
                    response = x.ResultData;
                } else {
                    response = x.value;
                }
                const formData = this.merchandiseArrivalHeaderDetailReassign(response);
                this.store.dispatch(new receiving.ReceivingformDetails(formData));
            }
        });
    }

    /**
     * @function getReceivingList();
     * @params None
     * @description Get Data from the Receiving
     * @output List the Reciveing Data
     */
    getReceivingList(receivingParams: any) {
        this.store.dispatch(new receiving.GetReceiving(receivingParams));
    }

    getReceivingData(): Observable<ReceivingList[]> {
        return this.store.pipe(select(selectReceivingViewModel));
    }

    getReceivingDataDetail(): Observable<MerchandiseArrivalHeaderDetail> {
        return this.headerDetailRestructure();
    }
    getReceivingDetailView(detailListParams: GetReceivingParamsDetaildById) {
        this.store.dispatch(new receiving.GetReceivingDetailById(detailListParams));
    }

    searchReceivingList(params: SearchModel) {
        this.store.dispatch(new receiving.GetReceivingSearch(params));
    }

    searchReceivingSorting(params: SortKeyObject) {
        this.store.dispatch(new receiving.GetReceivingSorting(params));
    }

    poSearchbyId(params: SearchById) {
        this.store.dispatch(new receiving.GetPoSearchbyId(params));
    }

    itemsearchList(searchParams: InventoryLookUpPost) {
        this.store.dispatch(new receiving.GetItemList(searchParams));
    }

    getsupplieritemNumberList(payload: SupplierItemLookUpPost) {
        this.store.dispatch(new receiving.GetSuppNumberItemList(payload));
    }

    getPoSearchSuccess(): Observable<PoLookupModel[]> {
        return this.lookupResctructure();
    }
    getLookUpdetailById(params: PodetailModel) {
        this.store.dispatch(new receiving.GetLookupDetail(params));
    }

    clearPoLookupData() {
        this.store.dispatch(new receiving.GetLookupDetail(null));
    }
    clearLoadPOItemDataOnSelection() {
        this.store.dispatch(new receiving.GetLookUpGridSuccess(null));
    }

    clearItemlistsearchdata() {
        this.store.dispatch(new receiving.GetItemListSuccess(null));
    }

    getLookupDetailSuccess(): Observable<MerchandiseArrivalHeaderDetail> {
        return this.createLookupViewModel();
    }

    getPoSummary(PoSummaryModel: any): void {
        this.store.dispatch(new receiving.GetItemPoSummary(PoSummaryModel));
    }

    getAllSupplierList(suplierModel: any) {
        this.store.dispatch(new receiving.GetSupplierList(suplierModel));
    }

    getAllLocationList(locationModel: any) {
        try {
            this.store.dispatch(new receiving.GetLocation(locationModel));
        } catch (error) {
            console.error('getAllLocationList error message', error);
        }
    }

    getSearchSuplier(Suplierkey: any) {
        try {
            this.store.dispatch(new receiving.GetSearchSupplier(Suplierkey));
        } catch (error) {
            console.error('getSearchSuplier error message', error);
        }
    }

    getSuplierSearchList(): Observable<SuplierViewList[]> {
        return this.reassignSupplierlist();
    }

    getitemlistData():any {
        try {
            return this.reassignitemlistData();
        } catch (error) {
            console.error('getitemlistData error message', error);
        }
    }

    GetSupplierItemNumberSuccess():any {
        try {
            return this.reassignSupplierItemNumberlistData();
        } catch (error) {
            console.error('getitemlistData error message', error);
        }
    }

    reassignSupplierArray(Suplierkey: any) {
        try {
            return this.store.pipe(select(selectItemListDetails)).pipe(
            )
        } catch (error) {
            console.error('getitemlistData error message', error);
        }
    }

    postReceivingData(PostReceivingMa: ReceivingPostModel) {
        try {
            this.store.dispatch(new receiving.PostReceiving(PostReceivingMa));
        } catch (error) {
            console.error('postReceivingData error message', error);
        }
    }

    SaveReceivingData(SaveReceivingMa: ReceivingPostModel) {
        try {
            this.store.dispatch(new receiving.SaveReceiving(SaveReceivingMa));
        } catch (error) {
            console.error('SaveReceivingData error message', error);
        }
    }

    getReceivingPostSuccess(): Observable<any> {
        try {
            return this.store.pipe(select(ReceivingSucess));
        } catch (error) {
            console.error('getReceivingPostSuccess error message', error);
        }
    }
    getReceivingSaveSuccess(): Observable<any> {
        try {
            return this.store.pipe(select(ReceivingSavedSuccess));
        } catch (error) {
            console.error('getReceivingPostSuccess error message', error);
        }
    }

    reassignSupplierlist(): Observable<SuplierViewList[]> {
        return this.store.pipe(select(selectSuplierList)).pipe(
            map(x => {
                const supplierArraylist = [];
                if (x !== null && x !== undefined && x) {
                    x.forEach(element => {
                        const suplierObject = {} as SuplierViewList;
                        suplierObject.SupplierId = element.Id;
                        suplierObject.SupplierName = element.Name;
                        suplierObject.SupplierNumber = element.Number;
                        supplierArraylist.push(suplierObject);
                    });
                    return supplierArraylist;
                }
            })
        );
    }

    reassignitemlistData(): any {
        try {
            return this.store.pipe(select(selectItemListDetails)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        console.log('reassignitemlistData');
                        x.ResultData.forEach(option => {
                            option["FullSearchText"] = (option.Name ? option.Name : '') + ' - #'
                              + (option.Number ? option.Number : '') + (option.Barcode ? ' - ' + option.Barcode : '')
                              + (option.Description ? ' - ' + option.Description : '')
                          });
                        return x;
                    }
                })
            );
        } catch (error) {
            console.error('reassignitemlistData error message', error);
        }
    }

    reassignSupplierItemNumberlistData(): any {
        try {
            return this.store.pipe(select(selectSupplierItemNumber)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        console.log('reassignitemlistData');
                        x[0]?.ResultData?.forEach(option => {
                            option["FullSearchText"] = (option.IngredientName ? option.IngredientName : '') + ' - #'
                              + (option.Number ? option.Number : '') + (option.BidNumber ? ' - ' + option.BidNumber : '')
                              + (option.SupplierName ? ' - ' + option.SupplierName : '')
                          });
                        return x[0];
                    }
                })
            );
        } catch (error) {
            console.error('reassignitemlistData error message', error);
        }
    }

    checkbarcodeData(lookupdata: any) {
        try {
            if (this.isBarcodeScan) {
                this.addgridData(lookupdata[0]);
                return null;
            } else {
                return lookupdata;
            }
        } catch (error) {
            console.error('checkbarcodeData error message', error);
        }
    }

    getlookupGridData() {
        try {
            return this.lookupGridDataReassign();
        } catch (error) {
            console.error('getlookupGridData error message', error);
        }
    }
    // :Observable<PurchaseModel[]>
    lookupGridDataReassign(): Observable<PurchaseModel[]> {
        try {
            return this.store.pipe(select(selectLookupGridDetails)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        this.purchaseModel = x;    
                        
                    return this.purchaseModel;                    
                    }
                    // else{
                    //     this.purchaseModel = [];
                    //     return this.purchaseModel;
                    // }
                })
            );
        } catch (error) {
            console.error('lookupGridDataReassign error message', error);
        }
    }


    createLookupViewModel(): Observable<MerchandiseArrivalHeaderDetail> {
        try {
            return this.store.pipe(select(ReceivingFormDetailSuccess)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        return x;
                    }
                })
            );
        } catch (error) {
            console.error('createLookupViewModel error message', error);
        }
    }

    createLookupPoSummary(): Observable<any> {
        try {
            return this.store.pipe(select(GetReceivingPoSumary)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        return x;
                    }
                })
            );
        } catch (error) {
            console.error('createLookupPoSummary error message', error);
        }
    }

    /**
     * @function lookupResctructure();
     * @param Input none
     * @description Rearrange the po search receiving data
     */
    lookupResctructure(): Observable<PoLookupModel[]> {
        return this.store.pipe(select(selectReceivingPoSearch)).pipe(
            map(x => {
                if (x !== null && x !== undefined && x) {
                    const lookupData = [];
                    this.poLookupModel = [];
                    x.forEach(element => {
                        const lookupmodel: LookupModel = {} as LookupModel;
                        lookupmodel.RevisionDesc = element.Id;
                        lookupmodel.SupplierName = element.VersionNo;
                        lookupData.push(lookupmodel);
                        this.poLookupModel = lookupData;
                    });
                    return this.poLookupModel;
                } else {
                    this.poLookupModel = null;
                }
            })
        );
    }


    /**
     * @function headerDataResctructure()
     * @param loadeParams;
     * @ouputparams none
     *
     */
    headerDetailRestructure(): Observable<MerchandiseArrivalHeaderDetail> {
        this.merchandiseArrivalHeaderDetail = {} as MerchandiseArrivalHeaderDetail;
        try {
            return this.store.pipe(select(selectReceivingDetailByidSuccess)).pipe(
                map(x => {
                    if (x !== null && x !== undefined && x) {
                        return this.merchandiseArrivalHeaderDetailReassign(x);
                    }
                })
            );
        } catch (error) {
            console.error('headerDetailRestructure error message', error);
        }
    }



    /**
     * @function loadReceivingHeaderDetails();
     * @params Input None
     * @param output none
     */

    loadHeaderDetails(loadeParams: ReceivingLoad) {
        try {
            const urlExtraParams: NavigationExtras = {
                queryParams: {
                    id: loadeParams.id,
                    name: loadeParams.name,
                    loadedevent: loadeParams.eventclicked,
                    loadfrom: loadeParams.eventclicked
                }
            };
            this.route.navigate(['receiving/request-detail/'], urlExtraParams);
        } catch (error) {
            console.error('loadHeaderDetails error message', error);
        }
    }

    /**
     * @function addGridOptionData
     * @params Grid Data
     * @description Add the grid data object to the Look up grid
     */

    addgridData(gridObject: any) {
        try {
            if (gridObject) {
                gridObject.Units = this.facadeService.CommonService.isonlineStatus ? JSON.parse(gridObject?.Units) : gridObject?.Units;
                const selectedUnit = this.facadeService.CommonService.isonlineStatus ? gridObject?.UnitTypeId : (gridObject?.CatchWeight === 2) ? gridObject?.Units.find((unitDetails: any) => unitDetails['UnitTypeId'] ===  appApiResources.UnitType.BaseUnit)?.UnitTypeId : appApiResources.UnitType.PurchaseUnit;
                const UnitDetails: UnitEntity = this.facadeService.GlobalConversionService.UnitDetailsCollection(gridObject.Units, selectedUnit);
                const TolerancePercentage = gridObject?.RecevingTolerance ?? gridObject.TolerancePercentage;
                const purchaseModel: PurchaseModel = {} as PurchaseModel;
                const gridArray : any = [];
                purchaseModel.PurchaseId = null;
                purchaseModel.InventoryId = gridObject.IngredientId || gridObject.Id;
                purchaseModel.Conversion = UnitDetails.Conversion;
                purchaseModel.Remarks = '';//gridObject.Remarks || gridObject.Remark || '-';
                purchaseModel.LoationId = gridObject.LocationId;
                purchaseModel.LocationId = gridObject.LocationId || this.merchandiseArrivalHeaderDetail?.LocationId;
                purchaseModel.LocationName = gridObject.LocationName || this.merchandiseArrivalHeaderDetail?.LocationName || this.facadeService.Receiving?.headLocationList?.find(location => location.Id === purchaseModel.LocationId)?.Name;
                purchaseModel.DepartmentId = this.merchandiseArrivalHeaderDetail?.DepartmentId;
                purchaseModel.DebitAccId = this.merchandiseArrivalHeaderDetail?.DebitAccId;
                purchaseModel.InvoiceDate = this.merchandiseArrivalHeaderDetail?.InvoiceDate;
                purchaseModel.PODetailId = null;
                purchaseModel.CurrentCost = gridObject.CurrentCost;
                purchaseModel.Number = gridObject.Number;
                purchaseModel.BarCode = gridObject.Barcode;
                purchaseModel.BidNumber = gridObject.BidNumber;
                purchaseModel.Name = gridObject.Name;
                purchaseModel.UnitsDetails = gridObject.Units;
                purchaseModel.UnitCost = UnitDetails.UnitCost;
                purchaseModel.oldUnitCost = UnitDetails.UnitCost;
                purchaseModel.isChecked = false;
                purchaseModel.TrackingFlag = gridObject.TrackingFlag;
                purchaseModel.PostPhyOnZeroCost = gridObject.PostPhyOnZeroCost ?? 2;
                purchaseModel.SelectedUnitId = UnitDetails.UnitId;
                purchaseModel.SelectedUnitTypeId = UnitDetails.UnitTypeId;
                purchaseModel.SelectedUnitType = UnitDetails.UnitCode + `(${UnitDetails.UnitTypeName})`
                purchaseModel.ExchangeRate = Number(sessionStorage.getItem('SupplierExchangeRate'));
                purchaseModel.ForeignCurrencyId = Number(sessionStorage.getItem('TransactionCurrencyId'));
                // purchaseModel.Quantity = this.assignQuantity(purchaseModel); // comemnt by karthi
                purchaseModel.Quantity = '';
                const quantity = (gridObject.Qty !== null) ? gridObject.Qty : 0;
                purchaseModel.TotalAmount = UnitDetails.UnitCost * quantity;
                purchaseModel.costChangePercentage = 0;
                purchaseModel.RecevingTolerance = TolerancePercentage;
                purchaseModel.CatchWeight = gridObject?.CatchWeight;
                purchaseModel.OnRecipt = gridObject.OnRecipt;
                purchaseModel.Tax1 = gridObject.Tax1;
                purchaseModel.Tax2 = gridObject.Tax2;
                purchaseModel.TaxAmount1 = gridObject.TaxAmount1;
                purchaseModel.TaxAmount2 = gridObject.TaxAmount2;
                purchaseModel.TaxRate1 = gridObject.TaxRate1;
                purchaseModel.TaxRate2 = gridObject.TaxRate2;
                purchaseModel.TaxName1 = gridObject.TaxName1;
                purchaseModel.TaxName2 = gridObject.TaxName2;
                purchaseModel.TypeName = gridObject.TypeName ?? gridObject?.IngredientTypes?.Name;
                purchaseModel.ClassName = gridObject.ClassName ?? gridObject?.Classes?.Name;
                purchaseModel.Description = gridObject.Description;
                purchaseModel.ShelfLife = gridObject?.ShelfLife;
                purchaseModel.ReceivingDetailsDepartments = this.facadeService?.Receiving?.headDepartmentList;
                purchaseModel.ReceivingDetailsChartOfAccounts = this.facadeService?.Receiving?.headAccountList;
                 purchaseModel.UnitsDetails.forEach(element => {
                    element.UnitCost = parseFloat(element.UnitCost.toFixed(4));
                    element.oldUnitCost = element.UnitCost;
                    element.UnitTypeId = (element.UnitTypeId === 0) ? 2 : element.UnitTypeId;
                  });
                  purchaseModel.Charges = 0;
                gridArray.push(purchaseModel);

                const postDate = this.merchandiseArrivalHeaderDetail?.PostDate;
                const shelfLife = gridObject?.ShelfLife;
                const dateFormat = 'YYYY-MM-DD';
                if( gridObject.TrackingFlag === 3 && postDate && shelfLife) {
                    purchaseModel.ExpireDate = moment(postDate).add(shelfLife, 'days').format(dateFormat);
                }

                if(this.facadeService.Receiving.merchandiseArrivalItemGridDetails == undefined || this.facadeService.Receiving.merchandiseArrivalItemGridDetails.length == 0){                
                    if (this._commonService.barcodeAutoIncrement == 'true') {
                        // gridArray[0].Quantity = (1/UnitDetails.Conversion);
                        if(gridObject.barcodeConversion !== undefined) {
                            gridArray[0].Quantity = (gridObject.barcodeConversion / UnitDetails.Conversion);
                        }
                    }
                    this.PostEnableDisable.next(!(gridArray[0].Quantity === ''));
                    this.store.dispatch(new receiving.GetLookUpGridSuccess(gridArray));
                }
                else{
                    let data = this.facadeService.Receiving.merchandiseArrivalItemGridDetails.filter(x => x.InventoryId == purchaseModel.InventoryId);
                     if(data && data.length > 0){
                        this.duplicateItem.next(purchaseModel.InventoryId);
                        let UnitDetail: UnitEntity = this.facadeService.GlobalConversionService.UnitDetailsCollection(data[0]?.UnitsDetails, data[0]?.SelectedUnitTypeId || 1);
                        if(this._commonService.barcodeAutoIncrement=='true'){
                            // this.facadeService.Receiving.merchandiseArrivalItemGridDetails.find(x => x.InventoryId ==  purchaseModel.InventoryId).Quantity = data[0].Quantity == '' ? Number(data[0].Quantity) + (2/UnitDetail.Conversion) : Number(data[0].Quantity) + (1/UnitDetail.Conversion);
                            if(gridObject.barcodeConversion !== undefined) {
                                this.facadeService.Receiving.merchandiseArrivalItemGridDetails.find(x => x.InventoryId ==  purchaseModel.InventoryId).Quantity = Number(data[0].Quantity) + (gridObject.barcodeConversion / UnitDetails.Conversion);
                                this.facadeService.Receiving.merchandiseArrivalItemGridDetails.find(x => x.InventoryId ==  purchaseModel.InventoryId).TotalAmount = UnitDetails.UnitCost * data[0].Quantity;
                                this.facadeService.Receiving.receivingTotalAmount = this.facadeService.Receiving.getItemTotalAmount();
                            }
                        }
                    }
                    else{
                        if(this._commonService.barcodeAutoIncrement == 'true'){
                            // gridArray[0].Quantity = (1/UnitDetails.Conversion);
                            if(gridObject.barcodeConversion !== undefined) {
                                gridArray[0].Quantity = (gridObject.barcodeConversion / UnitDetails.Conversion);
                            }
                        }
                        // this.purchaseModel = gridArray;
                        this.store.dispatch(new receiving.GetLookUpGridSuccess(gridArray));
                        this.facadeService.Receiving.receivingTotalAmount = this.facadeService.Receiving.getItemTotalAmount();
                    }
                    this.PostEnableDisable.next(!this.facadeService.Receiving.merchandiseArrivalItemGridDetails.every(x => x.Quantity === ''));
                }                
                this.inputSearchHistoryEntity = {
                    ItemId: gridObject.IngredientId,
                    SourceId: 49,
                    LocationId: Number(this.merchandiseArrivalHeaderDetail.LocationId)
                  };
     
              
               
                if (this.facadeService.CommonService.isonlineStatus)
                {
                  this.saveSearchHistory(this.inputSearchHistoryEntity);
                }
            }
        } catch (error) {
            console.error('gridObject error message', error);
        }
    }

    async saveSearchHistory(entity: SearchHistoryPostEntity) {
        // const postModel = this.requestService.PostRequestContraction(null,
        //   entity, appApiResources.EntityName.SearchHistory , null);
          
        await this.apiServiceProviderService.transactionService.SaveIngredientSearchHistory(entity).subscribe(
          response => { responseInfo : response as any; }, error => { });
      }

    assignQuantity(gridObject: any) {
        let returnquantity: any = '';
        try {
            if (
                this.facadeService.Receiving.isBarcodeScan &&
                JSON.parse(this.facadeService.CommonService.barcodeAutoIncrement.toString())) {
                var selectedItem = [];
                if (this.purchaseModel && this.purchaseModel.length > 0) {
                    selectedItem = this.purchaseModel.filter(x =>
                        x.SelectedUnitId === gridObject.SelectedUnitId &&
                        x.SelectedUnitTypeId === gridObject.SelectedUnitTypeId &&
                        x.InventoryId === gridObject.InventoryId
                    );
                }

                this.PostEnableDisable.next(true);
                returnquantity = 1; 

                //}
            } else {
                returnquantity = '';
            }

            return returnquantity;
        } catch (error) {
            console.log('error occured assignQuantity', error);
        }
    }

    sortArray(object: any) {
        object.sort(function (a, b) {
            return parseFloat(b.Quantity) - parseFloat(a.Quantity);
        });
        return object;
    }
    /**Clear store methods */

    /**
     * @function clearstore();
     * @param none
     * @description clear the store previous values
     */

    clearstore() {
        this.store.dispatch(new receiving.GetLookUpGridSuccess(null));
        this.store.dispatch(new receiving.GetLookUpDetailSuccess(null));
        this.store.dispatch(new receiving.PostReceivingSuccess(null));
        this.store.dispatch(new receiving.SaveReceivingSucess(null));
        this.store.dispatch(new receiving.ReceivingformDetails(null));
        this.store.dispatch(new receiving.GetReceivingViewModel(null));
    }

    clearPostContinueStore(){
        this.store.dispatch(new receiving.GetLookUpGridSuccess(null));
        this.store.dispatch(new receiving.SaveReceivingSucess(null));
    }

    clearRguestItemDetails(){
        this.store.dispatch(new receiving.GetLookUpGridSuccess(null));
    }

    postAndSaveResponseStoreClear() {
        this.store.dispatch(new receiving.PostReceivingSuccess(null));
        this.store.dispatch(new receiving.SaveReceivingSucess(null));
    }

    clearReceivinglanding() {
        this.store.dispatch(new receiving.GetReceivingSuccess(null));
        this.store.dispatch(new receiving.GetReceivingViewModel(null));
    }

    getInventoryOfflineList(InventoryOfflineResponse: any) {
        try {
            this.store.dispatch(new receiving.GetItemListSuccess(InventoryOfflineResponse));
        } catch (error) {
            console.log('error occured', error);
        }
    }

    /**
     * @funtion disabled Form 
     * @Input Params Form object
     * @Description disabled the form controls
     */

    disabledformControls(controlData: any, exceptcontrol: any) {
        Object.keys(controlData.controls).forEach(element => {
            const getIndex = exceptcontrol.findIndex(value => value === element);
            if (getIndex === -1) {
                controlData.controls[element].disable();
            }
        });
    }

    griddataReassign(InventoryIdArray: any) {
        try {
            if (InventoryIdArray.length > 0) {
                InventoryIdArray.forEach(element => {
                    const tempIndex = this.purchaseModel.findIndex(x =>
                        x.InventoryId === element.InventoryId &&
                        x.SelectedUnitTypeId === element.SelectedUnitTypeId &&
                        x.Quantity === element.Quantity);
                    if (tempIndex !== -1) {
                        this.purchaseModel.splice(tempIndex, 1);
                    }
                });
                this.purchaseModel.map(x => x.isChecked = false);
                const assignValue = (this.purchaseModel.length > 0) ? this.purchaseModel : null;
                this.store.dispatch(new receiving.GetLookUpGridSuccess(null));
                this.store.dispatch(new receiving.GetLookUpGridSuccess(assignValue));
            }
        } catch (error) {
            console.error('griddataReassign error message', error);
        }
    }

    /**
     * @param Input HeaderDetails Data
     * @description Reassign Model bind the Data
     */

    merchandiseArrivalHeaderDetailReassign(headerDetailData: any): MerchandiseArrivalHeaderDetail {
        try {
            if (headerDetailData) {
                if(headerDetailData?.TransactionMiscCharges?.length > 0) {
                    headerDetailData?.TransactionMiscCharges.forEach(x => {
                       x.CategoryDetailId = x.MiscChargeId,
                       x.CategoryId = 2,
                       x.Id = 0
                    });
                }
                let receivingHeadOtherTotals = headerDetailData?.TransactionMiscCharges ?? [];
                if(headerDetailData?.ReceivingHeadOtherTotals?.length > 0) {
                    receivingHeadOtherTotals = headerDetailData?.ReceivingHeadOtherTotals?.filter(element => element.CategoryId === 2);
                }
                const GetUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
                const UserName = (GetUserInfo && GetUserInfo.hasOwnProperty('UserName')) ? GetUserInfo.UserName : null;
                this.merchandiseArrivalHeaderDetail = {} as MerchandiseArrivalHeaderDetail;
                this.merchandiseArrivalHeaderDetail.InvoiceId = headerDetailData.InvoiceId;
                this.merchandiseArrivalHeaderDetail.InvoiceNumber = headerDetailData.InvoiceNumber;
                this.merchandiseArrivalHeaderDetail.SupplierId = headerDetailData.SupplierId || 0;
                this.merchandiseArrivalHeaderDetail.SupplierName = (headerDetailData.hasOwnProperty('ReceivingHeadSupplier')) ? headerDetailData.ReceivingHeadSupplier.Name : headerDetailData.POHeadSupplierId.Name;
                this.merchandiseArrivalHeaderDetail.PostDate = headerDetailData.PostDate ? moment(headerDetailData.PostDate).startOf('day').format() : headerDetailData.PostDate;
                this.merchandiseArrivalHeaderDetail.DueDate = (headerDetailData.hasOwnProperty('InvoiceDueDays')) ? moment(headerDetailData.PostDate).add(headerDetailData.InvoiceDueDays, 'days').format() : headerDetailData.hasOwnProperty('InvoiceDueDate') ?  headerDetailData.InvoiceDueDate : headerDetailData.PostDate;
                this.merchandiseArrivalHeaderDetail.InvoiceDueDays = headerDetailData.InvoiceDueDays || 0;
                this.merchandiseArrivalHeaderDetail.PayTermId = headerDetailData.PayTermId || headerDetailData.TermId || headerDetailData?.ReceivingHeadSupplier?.PayTermId || headerDetailData?.POHeadSupplierId?.PayTermId || null;
                this.merchandiseArrivalHeaderDetail.PONumber = (headerDetailData.hasOwnProperty('PONumber')) ? headerDetailData.PONumber : (headerDetailData.hasOwnProperty('VersionNo')) ? `${headerDetailData.Id},` + `${headerDetailData.VersionNo}` : headerDetailData.Id
                this.merchandiseArrivalHeaderDetail.POHeadId = (headerDetailData.hasOwnProperty('POHeadId')) ? headerDetailData.POHeadId : !this.facadeService.CommonService.offlineReceivingNavigation ? headerDetailData.Id : null;
                this.merchandiseArrivalHeaderDetail.LocationId = headerDetailData.LocationId || 0;
                this.merchandiseArrivalHeaderDetail.DebitAccId = headerDetailData.DebitAccId || 0;
                this.merchandiseArrivalHeaderDetail.DebitAccIdName = (headerDetailData.hasOwnProperty('ReceivingHeadDebitAcc')) ? headerDetailData?.ReceivingHeadDebitAcc?.Name : headerDetailData?.POHeadDebitAccId?.Name;
                this.merchandiseArrivalHeaderDetail.DepartmentId = headerDetailData.DepartmentId || 0;
                this.merchandiseArrivalHeaderDetail.DepartmentIdName = (headerDetailData.hasOwnProperty('ReceivingHeadDepartment')) ? headerDetailData?.ReceivingHeadDepartment?.Name : headerDetailData?.POHeadDepartmentId?.Name;
                this.merchandiseArrivalHeaderDetail.ItemTotal = headerDetailData?.Amount || headerDetailData?.SupplierTotal || headerDetailData?.POItemTotal; // headerDetailData.SupplierTotal || headerDetailData.POItemTotal
                this.merchandiseArrivalHeaderDetail.Remark = headerDetailData.Remark || null;
                this.merchandiseArrivalHeaderDetail.UserId = headerDetailData.Id || 0;
                this.merchandiseArrivalHeaderDetail.UserName = UserName
                this.merchandiseArrivalHeaderDetail.RNIOptionId = headerDetailData.hasOwnProperty('ReceivingHeadSupplier') ? headerDetailData.ReceivingHeadSupplier.RNIOptionId : headerDetailData.hasOwnProperty('POHeadSupplierId') ? headerDetailData?.POHeadSupplierId?.RNIOptionId : this.supplierlist.filter(dt=>dt.SupplierId == headerDetailData.SupplierId)[0]?.RNIOptionId;
                this.merchandiseArrivalHeaderDetail.IsReceiver = (this.activatedRoute?.snapshot?.queryParams?.loadfrom === 'poloaded') ?( this.merchandiseArrivalHeaderDetail.RNIOptionId === 1) ? 1 : 0 : headerDetailData.IsInvoiced ? 1 : 0;
                this.merchandiseArrivalHeaderDetail.LocationName = (headerDetailData.hasOwnProperty('ReceivingHeadLocation')) ? headerDetailData.ReceivingHeadLocation.Name : (headerDetailData.hasOwnProperty('PurchaseOrderHeadLocation')) ? headerDetailData.PurchaseOrderHeadLocation.Name : headerDetailData.LocationName// headerDetailData.LocationName
                this.merchandiseArrivalHeaderDetail.purchaseOrderDetails = headerDetailData.PurchaseOrderDetails;
                this.merchandiseArrivalHeaderDetail.ReceivingHeadOtherTotals = receivingHeadOtherTotals;
                this.merchandiseArrivalHeaderDetail.ExchangeRate = Number(sessionStorage.getItem('SupplierExchangeRate'));
                this.merchandiseArrivalHeaderDetail.BaseCurrencyId = headerDetailData.BaseCurrencyId;
                this.merchandiseArrivalHeaderDetail.TransactionCurrencyId = headerDetailData.TransactionCurrencyId;
                this.merchandiseArrivalHeaderDetail.CapexId = headerDetailData.CapexId;
                this.merchandiseArrivalHeaderDetail.IsConsignment = headerDetailData.IsConsignment;
                this.merchandiseArrivalHeaderDetail.isDisableConsignment = headerDetailData.IsConsignment;
                this.merchandiseArrivalHeaderDetail.InvoiceDate = headerDetailData.InvoiceDate ? moment(headerDetailData.InvoiceDate).startOf('day').format() : headerDetailData.InvoiceDate;
                this.isTaxExemption = headerDetailData.POHeadSupplierId?.IsTaxExemption ?? false;
                // this.merchandiseArrivalHeaderDetail.LocationName = (headerDetailData.hasOwnProperty('POHeadLocationId')) ? headerDetailData.POHeadLocationId.Name : headerDetailData.LocationName
                this.facadeService.CommonService.offlineReceivingNavigation = false;
                return this.merchandiseArrivalHeaderDetail;
            }

        } catch (error) {
            console.error('merchandiseArrivalHeaderDetailReassign error message', error);
        }
    }

    cancelselectItem() {
        try {
            this.purchaseModel.map(x => x.isChecked = false);
        } catch (error) {
            console.error('cancelselectItem error message', error);
        }
    }


    /**
     * @function formPostData()
     * @Input InvoiceModel and ItemList Model
     * @description Arrange the post receiving data
     */
    formPostData(headerdetails: any) {
        this.merchandiseArrivalHeaderDetail.PONumber = headerdetails.controls.PONumber.value;
        this.merchandiseArrivalHeaderDetail.SupplierName = headerdetails.controls.SupplierName.value;
        this.merchandiseArrivalHeaderDetail.DueDate = headerdetails.controls.DueDate.value;
        this.merchandiseArrivalHeaderDetail.PayTermId = headerdetails.controls.PayTermId?.value || null;
        this.merchandiseArrivalHeaderDetail.PostDate = headerdetails.controls.PostDate.value
            ? moment(headerdetails.controls.PostDate.value).startOf('day').format() : headerdetails.controls.PostDate.value;
        this.merchandiseArrivalHeaderDetail.UserName = headerdetails.controls.UserName.value;
        this.merchandiseArrivalHeaderDetail.LocationName = headerdetails.controls.LocationName.value;
        this.merchandiseArrivalHeaderDetail.InvoiceNumber = headerdetails.controls.InvoiceNumber.value;
        this.merchandiseArrivalHeaderDetail.IsReceiver = (headerdetails.controls.IsReceiver.value === 1) ? 1 : 0;
        this.merchandiseArrivalHeaderDetail.CapexId = headerdetails.controls.CapexId.value;
        this.merchandiseArrivalHeaderDetail.IsConsignment = headerdetails.controls.IsConsignment.value;
    }

    /**
     * @function NewReceivingformPostData()
     * @Input InvoiceModel and ItemList Model
     * @description Arrange the post receiving data
     */
    NewReceivingformPostData(headerdetails: any) {
        try {
            this.merchandiseArrivalHeaderDetail = {} as MerchandiseArrivalHeaderDetail;
            this.merchandiseArrivalHeaderDetail.SupplierId = headerdetails.SupplierId.SupplierId;
            this.merchandiseArrivalHeaderDetail.PostDate = headerdetails.PostDate
                ? moment(headerdetails.PostDate).startOf('day').format() : headerdetails.PostDate;
            this.merchandiseArrivalHeaderDetail.DueDate = headerdetails.DueDate;
            this.merchandiseArrivalHeaderDetail.PayTermId = headerdetails.PayTermId || null;
            this.merchandiseArrivalHeaderDetail.LocationId = headerdetails.LocationId;
            this.merchandiseArrivalHeaderDetail.LocationName = headerdetails.LocationName;
            this.merchandiseArrivalHeaderDetail.InvoiceNumber = headerdetails.InvoiceNumber;
            this.merchandiseArrivalHeaderDetail.DebitAccId = headerdetails.DebitAccId;
            this.merchandiseArrivalHeaderDetail.DepartmentId = headerdetails.DepartmentId;
            this.merchandiseArrivalHeaderDetail.IsReceiver = (headerdetails.IsReceiver === 1) ? 1 : 0;
            this.merchandiseArrivalHeaderDetail.CapexId = headerdetails.CapexId;
            this.merchandiseArrivalHeaderDetail.projectExpensed = headerdetails.CapexId ? true : false;
            this.merchandiseArrivalHeaderDetail.IsConsignment = headerdetails.IsConsignment;
            this.merchandiseArrivalHeaderDetail.RNIOptionId = headerdetails.SupplierId?.RNIOptionId;

            const storeHeaderDetails = {} as MerchandiseArrivalHeaderDetail;
            storeHeaderDetails.SupplierId = headerdetails.SupplierId;
            storeHeaderDetails.PostDate = headerdetails.PostDate
                ? moment(headerdetails.PostDate).startOf('day').format() : headerdetails.PostDate;
            storeHeaderDetails.DueDate = headerdetails.DueDate;
            storeHeaderDetails.PayTermId = headerdetails.PayTermId || null;
            storeHeaderDetails.LocationId = headerdetails.LocationId;
            storeHeaderDetails.LocationName = headerdetails.LocationName;
            storeHeaderDetails.InvoiceNumber = headerdetails.InvoiceNumber;
            storeHeaderDetails.DebitAccId = headerdetails.DebitAccId;
            storeHeaderDetails.DepartmentId = headerdetails.DepartmentId;
            storeHeaderDetails.IsReceiver = (headerdetails.IsReceiver === 1) ? 1 : 0;
            storeHeaderDetails.CapexId = headerdetails.CapexId;
            storeHeaderDetails.projectExpensed = headerdetails.CapexId ? true : false;
            storeHeaderDetails.IsConsignment = headerdetails?.IsConsignment;
            storeHeaderDetails.RNIOptionId = this.merchandiseArrivalHeaderDetail.RNIOptionId;
            this.storednewFormdata(storeHeaderDetails);
        } catch (error) {
            console.log('error occured NewReceivingformPostData', error);
        }
    }

    unitdetailReassign(selectedunit?: any, lookupdata?: any, index?: any) {
        const selectedValue = selectedunit.value != null || selectedunit.value != undefined ? lookupdata.UnitsDetails.filter(x => x.UnitTypeId === selectedunit.value).map(x => x.UnitId)[0] : 0;
        const seletedUnitType = selectedunit.value != null || selectedunit.value != undefined ? selectedunit.value : 0;
        this.purchaseModel[index].SelectedUnitId = selectedValue;
        this.purchaseModel[index].SelectedUnitTypeId = seletedUnitType;
        return this.selectedunittype(lookupdata.UnitsDetails, selectedValue, seletedUnitType);
    }
    
    /**
     * @input suplier Id
     * @OutPut Suplier Name
     * @description Get the suplier name from the suplier list Array
     */
    getSuplierName(SuplierId: number) {
        try {
            if (this.supplierlist.length > 0) {
                const suplierName = this.supplierlist.filter(x => x.SupplierId === SuplierId).map(x => x.SupplierName);
                return suplierName[0].toString();
            }
        } catch (error) {
        }
    }

    /**
     * @input suplier Id
     * @OutPut Suplier Name
     * @description Get the suplier name from the suplier list Array
     */
    getLocationName(LocationId: number) {
        try {
            if (this.locationList.length > 0) {
                const locationName = this.locationList.filter(x => x.LocationId === LocationId).map(x => x.LocationName);
                return locationName[0].toString();
            }
        } catch (error) {
        }
    }

    /**
* @input FormData
* @OutPut None
* @description Assign Form Data to Store
*/
    storednewFormdata(formdata: any) {
        try {
            if (formdata) {
                this.store.dispatch(new receiving.ReceivingformDetails(formdata));
            }
        } catch (error) {
        }
    }


    getPopupMessage(InvventoryIdArray: any) {
        let popupmessage: any;
        const filterPipe = null;
        const deleteConfirm = this.translateService.instant("receiveing.doYouWantToDelete");
        InvventoryIdArray.forEach(element => {
            popupmessage = this.purchaseModel.filter(x => x.InventoryId === element.InventoryId).map(x => {
                return deleteConfirm + " " + x.Name + " ?";
            });
        });
        console.log(popupmessage[0].toString());
        return popupmessage[0].toString();
    }

    checkInvoiceVoucher(InventoryList: any, supplierList: Array<any>) {
        try {
            let InvoiceEnable: boolean;
            const getInventoryList = supplierList.filter(
                x => InventoryList.SupplierId === x.SupplierId);
            if (getInventoryList && getInventoryList.length > 0 && getInventoryList[0].RNIOptionId > -1) {
                if (getInventoryList[0].RNIOptionId === 2) {
                    InventoryList['IsReceiver'] = (InventoryList.IsReceiver && InventoryList.IsReceiver >= 0) ?
                        InventoryList.IsReceiver : false;
                    InvoiceEnable = true;
                } else {
                    InvoiceEnable = false;
                    if (getInventoryList[0].RNIOptionId === 0) {
                        InventoryList['IsReceiver'] = (InventoryList.IsReceiver && InventoryList.IsReceiver >= 0) ?
                            InventoryList.IsReceiver : false;
                    } else {
                        InventoryList['IsReceiver'] = (InventoryList.IsReceiver && InventoryList.IsReceiver >= 0) ?
                            InventoryList.IsReceiver : true;
                    }
                }
                return InvoiceEnable;
            }
            console.log(getInventoryList);
        } catch (error) {
            console.log('error occured checkInvoiceVoucher', error);
        }
    }

    checkNewInvoiceVoucher(InventoryList: any, supplierId: number, supplierList?: Array<any>) {
        try {
            let InvoiceEnable: boolean = false;
            InventoryList.controls.IsReceiver.setValue(null);
            if (supplierList && supplierList.length > 0) {
                const getInventoryList = supplierList.filter(
                    x => supplierId === x.SupplierId);
                if (getInventoryList && getInventoryList.length > 0 && getInventoryList[0].hasOwnProperty('RNIOptionId') && getInventoryList[0].RNIOptionId > 0) 
                {
                    var RNIoptionId = getInventoryList[0]=== null || getInventoryList[0]=== undefined? 1 : getInventoryList[0].RNIOptionId;
                    if (RNIoptionId === 2) {
                        InventoryList.controls.IsReceiver.setValue(0);
                        InvoiceEnable = false;
                    } else {                        
                        if (RNIoptionId === 3) {
                            InvoiceEnable = true;
                            InventoryList.controls.IsReceiver.setValue(null);
                        } else {
                            InvoiceEnable = false;
                            InventoryList.controls.IsReceiver.setValue(1);
                        }
                    }
                    return InvoiceEnable;
                }
            }
        } catch (error) {
            console.log('error occured checkInvoiceVoucher', error);
        }
    }

    getItemTotalAmount(fromPost = false) {
        try {
            let TotalItemAmount = this.facadeService.Receiving?.totalMiscCharges ?? 0;
            let Valued = 0;
            const taxeswhenReceiving = this.globalservice.globalSystemPreference?.find(x => x?.LookupName === "TaxeswhenReceiving")?.LookupValue;
            if (this.purchaseModel && this.purchaseModel.length > 0) {
                this.purchaseModel.forEach(x => {
                    if ((isNaN(Number(x.Quantity)) || Number(x.Quantity) === 0) && x.Quantity !== '') {
                        x.Quantity = 0;
                    }
                    const UnitcostObject = this.selectedunittype(x.UnitsDetails, x.SelectedUnitId, x.SelectedUnitTypeId);
                    const assignValue = (x.Quantity === '') ? 0 : x.Quantity;
                    const AllocatedCharges = (x.Charges === '') ? 0 : Number(x.Charges);
                    const exchangeRate = parseFloat(sessionStorage.getItem('SupplierExchangeRate'));
                    const unitCost = (Number(x?.UnitCost) ?? parseFloat(UnitcostObject.UnitCost));
                    
                    x.AmountInFC = parseFloat(assignValue) * unitCost * exchangeRate;
                    x.EstimatedTotal = parseFloat(assignValue) * unitCost;
                    x.TotalAmount = (parseFloat(assignValue) * unitCost) + AllocatedCharges;
                    TotalItemAmount += (parseFloat(assignValue) * unitCost) + AllocatedCharges;
                    Valued = (parseFloat(assignValue) * unitCost);
                    // if (x.OnRecipt) {
                    this.taxCalculation(x , Valued);
                    // }
                    if (taxeswhenReceiving === 1 && fromPost) {
                        const tax1 = x.TaxAmount1 ?? 0;
                        const tax2 = x.TaxAmount2 ?? 0;
                        TotalItemAmount += (tax1 + tax2);
                    }
                });
                return TotalItemAmount;
            }
        } catch (error) {
            console.log('error getItemTotalAmount', error);
        }
    }

    taxCalculation(item, itemTotalAmount) {
        try {
            const payload = [];
            const taxList = (item.TransactionTaxAmount?.length > 0) ? item.TransactionTaxAmount : item?.ReceivingItemsOtherTotals?.filter(element => element.CategoryId === 1);
            if (taxList?.length > 0 && item?.OnRecipt && !this.isTaxExemption) { // saved record
                taxList.forEach((x, index) => {
                let  ispoloaded = (this.activatedRoute?.snapshot?.queryParams?.loadfrom === 'poloaded') ? true : false;
                if (x.SortOrder === 1 || index === 0) {
                  payload.push({
                    Id: ispoloaded ? 0: x.Id,
                    CategoryId: 1,
                    Amount: x.TaxRate * itemTotalAmount / 100,
                    AmountInFC: item.AmountInFC,
                    CategoryDetailId: x.TaxId ?? x.CategoryDetailId,
                    IsMisc: item.IsMisc ?? false,
                    TaxRate: x.TaxRate
                  });
                  item.TaxAmount1 = x.TaxRate * itemTotalAmount / 100;
                  item.TaxName1 = x?.Name ?? x.TaxName;
                }
                if (x.SortOrder === 2 || index === 1) {
                  payload.push({
                    Id: ispoloaded ? 0 : x.Id,
                    CategoryId: 1,
                    Amount: x.TaxRate * itemTotalAmount / 100,
                    AmountInFC: item.AmountInFC,
                    CategoryDetailId: x.TaxId ?? x.CategoryDetailId,
                    IsMisc: item.IsMisc ?? false,
                    TaxRate: x.TaxRate
                  });
                  item.TaxAmount2 = x.TaxRate * itemTotalAmount / 100;
                  item.TaxName2 = x?.Name ?? x.TaxName;
                }
              });
            } else { // new record
                if (item.OnRecipt && !this.isTaxExemption) {
                    item.TaxAmount1 = (item?.TaxRate1 || 0) * itemTotalAmount / 100;
                    item.TaxAmount2 = (item?.TaxRate2 || 0) * itemTotalAmount / 100;
                } else {
                    item.TaxAmount1 = 0;
                    item.TaxAmount2 = 0;
                }
              const taxes = [
                { amount: item.TaxAmount1, taxId: item.Tax1, rate: (item?.TaxRate1 || 0), sortOrder: 1 },
                { amount: item.TaxAmount2, taxId: item.Tax2, rate: (item?.TaxRate2 || 0), sortOrder: 2 }
              ];
    
                taxes.forEach(tax => {
                    if (tax.taxId) {
                        payload.push({
                            Id: 0,
                            CategoryId: 1,
                            Amount: tax.amount,
                            AmountInFC: tax.amount * item.ExchangeRate,
                            CategoryDetailId: tax.taxId,
                            IsMisc: item.IsMisc ?? false,
                            TaxRate: tax.rate
                        });
                    }
                });
            }
            item.transactionTaxAmount = payload;
        } catch (error) {
          console.error(error);
        }
      }
    
    selectedunittype(UnitTypeArray: UnitsDetails[], UnitId: number, unitType: number = -1) {
        let selectedUnitType: any;
        let UnitType = 0;
        let unitCount = 0;
        if (unitType === -1) {
            unitCount = UnitTypeArray.filter(x => x.UnitId == UnitId).length;
        }
        else {
            UnitType = unitType === 0 ? -2 : unitType;
        }
        if (unitType === -1) {
            if (unitCount === 0) {
                selectedUnitType = UnitTypeArray.filter(x => x.UnitTypeId == appApiResources.UnitType.TransactionUnit).map(x => {
                    const UnitType = this.translateService.instant(`receiveing.${x.UnitTypeName.toString().replace(/\s/g, "").toLowerCase().trim()}`);
                    return {
                        UnitType: `${x.UnitCode}(${UnitType || ''})`.toString(),
                        // UnitCost: x.UnitCost,
                        UnitCost: (x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? (x.UnitCost === 0 ? 1 : x.UnitCost) : x.UnitCost, //(x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? (x.Conversion === 0 ? 1 : x.Conversion) : x.Conversion,
                        packsize: x.Conversion,//x.PackSize
                        SelectedUnitTypeId: x.UnitTypeId,
                        SelectedUnitId: x.UnitId,
                        Conversion: x.Conversion
                    };
                });
            } else {
                selectedUnitType = UnitTypeArray.filter(x => x.UnitId == UnitId).map(x => {
                    let unitTypeName = x.UnitTypeName ? x.UnitTypeName : x.UnitName;
                    const UnitType = this.translateService.instant(`receiveing.${unitTypeName.toString().replace(/\s/g, "").toLowerCase().trim()}`);
                    return {
                        UnitType: `${x.UnitCode}(${UnitType || ''})`.toString(),
                        // UnitCost: x.UnitCost, 
                        UnitCost: (x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? 1 / (x.UnitCost === 0 ? 1 : x.UnitCost) : x.UnitCost, //(x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? 1 / (x.Conversion === 0 ? 1 : x.Conversion) : x.Conversion,
                        packsize: x.Conversion,//x.PackSize
                        SelectedUnitTypeId: x.UnitTypeId,
                        SelectedUnitId: x.UnitId,
                        Conversion: x.Conversion
                    };
                });
            }
        }
        else {
            UnitType = UnitType === -2 ? 0 : UnitType;
            selectedUnitType = UnitTypeArray.filter(x => x.UnitTypeId == UnitType).map(x => {
                const UnitType = x.UnitTypeName ? this.translateService.instant(`receiveing.${x.UnitTypeName.toString().replace(/\s/g, "").toLowerCase().trim()}`) : '';
                return {
                    UnitType: `${x.UnitCode}(${UnitType || ''})`.toString(),
                    // UnitCost: x.UnitCost, 
                    UnitCost: (x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? (x.UnitCost === 0 ? 1 : x.UnitCost) : x.UnitCost, //(x.UnitTypeId === appApiResources.UnitType.RecipeUnit) ? (x.Conversion === 0 ? 1 : x.Conversion) : x.Conversion,
                    packsize: x.Conversion,
                    SelectedUnitTypeId: x.UnitTypeId,
                    SelectedUnitId: x.UnitId,
                    Conversion: x.Conversion,
                    oldUnitCost: x.oldUnitCost
                };
            });
        }

        return selectedUnitType[0];
    }

    handledReceivingresponse(ReceivingResponse: ValidationEntity): PopupModel {
        try {
            if (ReceivingResponse) {
                if (ReceivingResponse.MessageType === 'Confirm') {
                    const result: PopupModel = {
                        DialogType: 'Info',
                        PopupHeader: this.translateService.instant("common.confirm"),
                        PopupContent: 'Saved SuccessFully'
                    };
                    return result;
                } else if (ReceivingResponse.MessageType === 'Success') {
                    const result: PopupModel = {
                        DialogType: 'Success',
                        PopupHeader: this.translateService.instant("common.Success"),
                        PopupContent: (this.facadeService.Receiving.actionItem === SETTINGCONFIG.Keys.Save) ?
                            'receiveing.popupsavesuccess' : 'receiveing.popuppostsuccess'
                    };
                    return result;
                } else if (ReceivingResponse.MessageType === 'Warning') {
                    const result: PopupModel = {
                        DialogType: this.translateService.instant("common.warning"),
                        PopupHeader: 'receiveing.partialreceiving',
                        PopupContent: 'receiveing.itempartially'
                    };
                    return result;
                } else if (ReceivingResponse.MessageType === 'Info' || ReceivingResponse.MessageType === 'PostConfirm') {
                    const result: PopupModel = {
                        DialogType: ReceivingResponse.MessageType === 'PostConfirm' ? 'Confirm' : ReceivingResponse.MessageType,
                        PopupHeader: ReceivingResponse.MessageType === 'PostConfirm' ? 'Confirm' : ReceivingResponse.MessageType,
                        PopupContent: ReceivingResponse.ReturnMessage
                    };
                    return result;
                } else if (ReceivingResponse.MessageType === 'Error') {
                    const result: PopupModel = {
                        DialogType: 'Info',
                        PopupHeader: this.translateService.instant("common.error"),
                        PopupContent: ReceivingResponse.ReturnMessage
                    }; 
                    return result;
                } else if (ReceivingResponse.MessageType === 'LotValidationError') {
                    const result: PopupModel = {
                        DialogType: 'Info',
                        PopupHeader: this.translateService.instant("common.ValidationFailed"),
                        PopupContent: ReceivingResponse.ReturnMessage
                    }; 
                    return result;
                }
            }
        } catch (error) {
            console.log('error occured   handledReceivingresponse', error)
        }
    }

    CreatePostSavedMa() {
        try {
            const currencyDecimalPlace = Number(sessionStorage.getItem(appApiResources.loggedInCurrencyViewValue));
            const supplierExchangeRate = Number(sessionStorage.getItem('SupplierExchangeRate'));
            const headerDetail = {} as PostMerchandiseArrivalHeaderDetail;
            const ItemModelArray: PostMerchandiseArrivalItemDetails[] = [];
            headerDetail.InvoiceId = 0;
            headerDetail.InvoiceNumber = this.merchandiseArrivalHeaderDetail.InvoiceNumber;
            headerDetail.LocationId = this.merchandiseArrivalHeaderDetail.LocationId;
            headerDetail.LoggedInSiteId = this.merchandiseArrivalHeaderDetail.LoggedInSiteId;
            headerDetail.PONumber = this.merchandiseArrivalHeaderDetail.PONumber;
            headerDetail.POHeadId = this.merchandiseArrivalHeaderDetail.POHeadId;
            headerDetail.PostDate = this.merchandiseArrivalHeaderDetail.PostDate 
                ? moment(this.merchandiseArrivalHeaderDetail.PostDate).startOf('day').format() : this.merchandiseArrivalHeaderDetail.PostDate;
            headerDetail.Reason = this.merchandiseArrivalHeaderDetail.Remark;
            headerDetail.Remark = this.merchandiseArrivalHeaderDetail.Remark;
            headerDetail.SupplierId = this.merchandiseArrivalHeaderDetail.SupplierId;
            headerDetail.IsInvoiced = this.merchandiseArrivalHeaderDetail.IsReceiver === 1 ? true : false;
            headerDetail.InvoiceDate = this.merchandiseArrivalHeaderDetail.InvoiceDate;
            headerDetail.InvoiceDueDate = this.merchandiseArrivalHeaderDetail.DueDate;
            headerDetail.DepartmentId = this.merchandiseArrivalHeaderDetail.DepartmentId > 0 ? this.merchandiseArrivalHeaderDetail.DepartmentId : null;
            headerDetail.DebitAccId = this.merchandiseArrivalHeaderDetail.DebitAccId > 0 ? this.merchandiseArrivalHeaderDetail.DebitAccId : null;
            headerDetail.SavedMAId = this.merchandiseArrivalHeaderDetail.InvoiceId || 0;
            headerDetail.CapexId = this.merchandiseArrivalHeaderDetail.CapexId;
            headerDetail.PayTermId = this.merchandiseArrivalHeaderDetail.PayTermId || null;
            headerDetail.AllowZeroCostItem = false;
            const totalAmount = this.getItemTotalAmount(true);
            headerDetail.TotalAmount = this.merchandiseArrivalHeaderDetail?.TotalAmount || this.merchandiseArrivalHeaderDetail.ItemTotal;
            headerDetail.SupplierTotal = totalAmount.toFixed(currencyDecimalPlace);
            // Mobile has no supplier-total reconcile UI; match web confirm-post and skip exact Amount mismatch.
            headerDetail.IsUICalculated = true;
            headerDetail.LoggedInSiteId = null;
            headerDetail.IsPosted = (this.facadeService.Receiving.actionItem === SETTINGCONFIG.Keys.Save) && this.facadeService.CommonService.isonlineStatus ? false : true;
            headerDetail.isBackOrder = this.merchandiseArrivalHeaderDetail.IsBackOrder || 0;
            headerDetail.IsReceiver = this.merchandiseArrivalHeaderDetail.IsReceiver; 
            headerDetail.IsConsignment = this.merchandiseArrivalHeaderDetail.IsConsignment ? true : false;
            headerDetail.BaseCurrencyId = Number(sessionStorage.getItem('BaseCurrencyId'));
            headerDetail.TransactionCurrencyId = Number(sessionStorage.getItem('TransactionCurrencyId'));
            headerDetail.ExchangeRate = (1/supplierExchangeRate).toFixed(4); // For Receiving Transaction Currency to Base Currency conversion
            headerDetail.ReceivingHeadOtherTotals = this.merchandiseArrivalHeaderDetail.ReceivingHeadOtherTotals;
            this.purchaseModel.forEach(element => {
                const itemDetails = {} as PostMerchandiseArrivalItemDetails;
                itemDetails.Id = element.Id;
                itemDetails.RecevingHeadId = element?.PurchaseId || 0;
                itemDetails.InventoryId = element.InventoryId;
                itemDetails.Quantity = element.Quantity.toString();
                itemDetails.Remarks = element.Remarks;
                itemDetails.ReceiverRemarks = element.ReceiverRemarks;
                itemDetails.SelectedUnitId = element.SelectedUnitId;
                itemDetails.SelectedUnitTypeId = element.SelectedUnitTypeId;
                itemDetails.InventoryName = element.Name;
                itemDetails.Barcode = element.BarCode;
                itemDetails.UnitId = element.SelectedUnitId;
                itemDetails.Qty = element.Quantity.toString();;
                itemDetails.IsDeleted = false;
                itemDetails.Conversion = (!element.hasOwnProperty('Conversion') || element.Conversion === null || element.Conversion === 0) ? 1 : element.Conversion;
                itemDetails.ItemLotLabelQty = 1;
                itemDetails.LocationId = element.LocationId || this.merchandiseArrivalHeaderDetail?.LocationId || 0;
                itemDetails.UnitTypeId = (element.SelectedUnitTypeId === -1) ? appApiResources.UnitType.PurchaseUnit : element.SelectedUnitTypeId;
                itemDetails.IngredientId = element.InventoryId;
                itemDetails.Temperature = element.Temperature;
                itemDetails.OverrideDepartmentId = element.DepartmentId ?? element.OverrideDepartmentId;
                itemDetails.OverrideAccountId = element.DebitAccId ?? element.OverrideAccountId;
                itemDetails.IsDeleted = false;
                itemDetails.PODetailId = element.PODetailId > 0 ? element.PODetailId : null;
                itemDetails.SupplierId = this.merchandiseArrivalHeaderDetail.SupplierId;
                itemDetails.ExchangeRate = Number(sessionStorage.getItem('SupplierExchangeRate'));
                itemDetails.ForeignCurrencyId = Number(sessionStorage.getItem('TransactionCurrencyId'));
                itemDetails.Amount = element.AmountInFC;                
                itemDetails.AmountInFC =  element.AmountInFC;
                itemDetails.UnitCost = (element.SelectedUnitTypeId === appApiResources.UnitType.RecipeUnit) ? (element.UnitCost === 0 ? 1 : element.UnitsDetails.filter(x=>x.UnitTypeId === element.SelectedUnitTypeId)[0].UnitCost) : element.UnitCost > 0 ? element.UnitCost : element.UnitsDetails.filter(x=>x.UnitTypeId === element.SelectedUnitTypeId)[0].UnitCost;
                itemDetails.RecevingTolerance = element.RecevingTolerance;
                itemDetails.costChangePercentage = element.costChangePercentage;
                itemDetails.PostPhyOnZeroCost = element.PostPhyOnZeroCost ?? 2;
                itemDetails.ChargesInFC = element?.Charges ?? 0;
                itemDetails.IngBidNumber = element?.BidNumber;
                itemDetails.ConsignmentBatchName = element?.ConsignmentBatchName;
                itemDetails.LotNumber = element?.LotNumber;
                itemDetails.ManufactureDate = element?.ManufactureDate;
                itemDetails.ExpireDate = element?.ExpireDate;
                itemDetails.ShelfLife = element?.ShelfLife;
                if(!this.facadeService.CommonService.isonlineStatus) {
                itemDetails.OnRecipt = element.OnRecipt;
                }
                if(element.Id > 0) {
                    itemDetails.ReceivingItemsOtherTotals = element.ReceivingItemsOtherTotals.filter(x => x.CategoryId === 3);
                    element.transactionTaxAmount.forEach(x=> {
                        itemDetails.ReceivingItemsOtherTotals.push(x);
                    })
                } else {
                    itemDetails.ReceivingItemsOtherTotals = [{
                        'Id': 0,
                        'CategoryId': 3,
                        'CategoryDetailId': element.UseId ?? 1,
                        'Amount': parseFloat(element.Charges),
                        'AmountInFC': Number((parseFloat(element.Charges) * element.ExchangeRate).toFixed(4))
                    }];
                    element.transactionTaxAmount.forEach(x=> {
                        itemDetails.ReceivingItemsOtherTotals.push(x);
                    })
                }
                const systemPreferenceCheckParams:SystemPrefModel = {
                    LookupName: "ZeroquantityOKintransactions",
                    LookupValue: 0
                }
                if(!this.globalservice.systemPreferenceCheck(systemPreferenceCheckParams)){                    
                    ItemModelArray.push(itemDetails);
                }
                else if(this.globalservice.systemPreferenceCheck(systemPreferenceCheckParams)){
                    //if(itemDetails.Qty != 0)
                        ItemModelArray.push(itemDetails);
                }                    
            });

            if (ItemModelArray.filter(x => x.UnitCost == 0 && x.PostPhyOnZeroCost != 2).length > 0)
                headerDetail.AllowZeroCostItem = false;
            else if (ItemModelArray.filter(x => x.UnitCost == 0 && x.PostPhyOnZeroCost == 2).length > 0)
                headerDetail.AllowZeroCostItem = true;

            const postMaObject: PostSavedMA = {
                MerchandiseArrivalHeaderDetail: headerDetail,
                MerchandiseArrivalItemDetails: ItemModelArray
            }
            const postModel = this.facadeService.RequestService.PostRequestContraction(ItemModelArray, headerDetail, EntityName.ReceivingHead, EntityName.ReceivingDetails);
            if (postModel?.PostDate)  {
              postModel.PostDate = moment(postModel.PostDate).startOf('day').format();
            }
            postModel.TransactionDate = this._commonService.getUTCDate(postModel.PostDate);
            // Ensure flag survives OData contraction defaults (boolean missing → false).
            postModel.IsUICalculated = true;
            return postModel;
        } catch (error) {
            console.log('errror occurance CreatePostSavedMa', error)
        }
    }

    snackbarsuccessMessage(DialogMessage: SnackbarMessage) {
        this.snackBar.openFromComponent(ReceivingSnackbarComponent, {
            duration: 5 * 1000,
            data: { Message: DialogMessage.Message, action: 'string' }
        });
    }

    getInvoiceDetailsByIdoffline(offlineResponse: any) {
        try {
            this.store.dispatch(new receiving.GetReceivingDetailByIdSucess(offlineResponse));
            this.store.dispatch(new receiving.GetLookUpGridSuccess(this.reAssignData(offlineResponse)));
        } catch (error) {
            console.log('error oocured', error);
        }
    }

    reAssignData(responseData: any) {
        let gridArray = [];
        const receivingData: any = (typeof responseData['value'] === 'string') ?
            JSON.parse(responseData['value']) : responseData['value'];
        if (receivingData && receivingData.hasOwnProperty('ReceivingDetails') && receivingData.ReceivingDetails.length > 0) {
            const receivingDetailArray = this.constarctLookuDetailData(receivingData.ReceivingDetails);
            gridArray = [...receivingDetailArray]
        }
        return this.purchaseModelArray = gridArray;
    }

    constarctLookuDetailData(ReceivingDetailsData: Array<any>): Array<PurchaseModel> { // Offline Item details
        try {
            const purchaseModelArray: Array<PurchaseModel> = [];
            ReceivingDetailsData.forEach(element => {
                const purchaseModel: PurchaseModel = {} as PurchaseModel;
                purchaseModel.PurchaseId = element.RecevingHeadId;
                purchaseModel.InventoryId = element.IngredientId;
                purchaseModel.Quantity = element.Qty;
                purchaseModel.TotalAmount = element.UnitCost * element.Qty
                purchaseModel.UnitId = element.UnitId;
                purchaseModel.Conversion = element.Conversion;
                purchaseModel.Remarks = element?.Remarks ?? element?.Remarks ?? '';
                purchaseModel.ReceiverRemarks = element?.ReceiverRemarks ?? '';
                purchaseModel.SupplierId = element.SupplierId;
                purchaseModel.LoationId = element.LocationId;
                purchaseModel.LocationId = element.LocationId || this.merchandiseArrivalHeaderDetail?.LocationId;
                purchaseModel.LocationName = element.LocationName || this.merchandiseArrivalHeaderDetail?.LocationName;
                purchaseModel.PODetailId = element.PODetailId > 0 ? element.PODetailId : null;
                purchaseModel.CurrentCost = element.UnitCost;
                purchaseModel.Number = element.ReceivingDetailsIngredient.Number;
                purchaseModel.BarCode = element.ReceivingDetailsIngredient.BarCode;
                purchaseModel.Name = element.ReceivingDetailsIngredient.Name;
                purchaseModel.UnitsDetails = element.ReceivingDetailsIngredient.Units;
                purchaseModel.isChecked = false;
                purchaseModel.PostPhyOnZeroCost = element.ReceivingDetailsIngredient?.IngredientsOtherDetails?.PostPhyOnZeroCost ?? 2;
                purchaseModel.SelectedUnitId = element.UnitId;
                purchaseModel.SelectedUnitTypeId = element.UnitTypeId;
                purchaseModel.UnitCost = element.UnitCost;
                purchaseModel.SelectedUnitType = element.Units.Name;
                purchaseModel.Id = element.Id
                purchaseModel.RecevingTolerance = element?.RecevingTolerance;
                purchaseModel.costChangePercentage = element?.costChangePercentage;
                purchaseModel.ConsignmentBatchName = element?.ConsignmentBatchName;
                if(!this.facadeService.CommonService.isonlineStatus) {
                purchaseModel.Charges = element?.ChargesInFC ?? 0;
                purchaseModel.ReceivingItemsOtherTotals = element?.ReceivingItemsOtherTotals;
                purchaseModel.OnRecipt = element.OnRecipt;
                purchaseModel.Temperature = element?.Temperature;
                purchaseModel.AccountId = element?.AccountId;
                purchaseModel.Amount = element?.Amount;
                purchaseModel.ConsignmentBatch = element?.ConsignmentBatch;
                purchaseModel.OverrideDebitAccountString = element?.OverrideDebitAccountString;
                purchaseModel.DepartmentId = element?.OverrideDepartmentId;
                purchaseModel.DebitAccId = element?.OverrideAccountId;
                purchaseModel.InvoiceQty = element?.InvoiceQty;
                purchaseModel.ShelfLife = element?.ShelfLife;
                purchaseModel.TrackingFlag = element?.TrackingFlag;
                }
                purchaseModelArray.push(purchaseModel);
            });
            return purchaseModelArray;
        } catch (error) {
            console.error(error);
        }
    }

    reassigngridModel(griddata: any) {
        const gridArray = [];
        griddata.MerchandiseArrivalItemDetails.forEach(element => {
            const purchaseModel: PurchaseModel = {} as PurchaseModel;
            purchaseModel.PurchaseId = element.PurchaseId;
            purchaseModel.InventoryId = element.InventoryId;
            purchaseModel.Quantity = element.Quantity;
            purchaseModel.TotalAmount = this.selectedunittype(element.UnitsDetails, element.UnitId).UnitCost * element.Quantity;
            purchaseModel.UnitId = element.UnitId;
            purchaseModel.Conversion = this.selectedunittype(element.UnitsDetails, element.UnitId).packsize;
            purchaseModel.Remarks = element?.Remarks ?? element?.Remarks ?? null;
            purchaseModel.ReceiverRemarks = element?.ReceiverRemarks ?? '';
            purchaseModel.SupplierId = element.SupplierId;
            purchaseModel.LoationId = element.LocationId || this.merchandiseArrivalHeaderDetail?.LocationId;
            purchaseModel.LocationId = element.LocationId;
            purchaseModel.LocationName = element.LocationName || this.merchandiseArrivalHeaderDetail?.LocationName;
            purchaseModel.PODetailId = element.PODetailId;
            purchaseModel.CurrentCost = element.CurrentCost;
            purchaseModel.BarCode = element.BarCode;
            purchaseModel.Name = element.Name;
            purchaseModel.UnitsDetails = element.UnitsDetails;
            purchaseModel.isChecked = false;
            purchaseModel.SelectedUnitId = this.selectedunittype(element.UnitsDetails, element.UnitId).SelectedUnitId;
            purchaseModel.SelectedUnitTypeId = this.selectedunittype(element.UnitsDetails, element.UnitId).SelectedUnitTypeId;
            purchaseModel.SelectedUnitType = this.selectedunittype(element.UnitsDetails, element.UnitId).UnitType;
            gridArray.push(purchaseModel);
        });
        return this.purchaseModelArray = gridArray;
    }

    onAudioPlay(isSuccess: boolean) {
        this.soundMode = window.localStorage.getItem('soundmode');
        if (this.soundMode === 'true') {
            const sound = isSuccess === true ? `../assets/BeepAudio/success.mp3` : `../assets/BeepAudio/failure.mp3`;
            const audio = new Audio(sound);
            audio.play();
        }
    }

    getSupplierOfflineList(SupplierOfflineResponse: any) {
        try {
            this.store.dispatch(new receiving.GetSupplierSuccess(SupplierOfflineResponse));
        } catch (error) {
            console.log('error occured', error);
        }
    }

    getLocationOfflineList(locationOfflineResponse: any) {
        try {
            this.store.dispatch(new receiving.GetLocationSuccess(locationOfflineResponse));
        } catch (error) {
            console.log('error occured', error);
        }
    }

    GetAllReceiving(RequisitionRequestPayload: any): Observable<any> {
        const requisitionRequestUrl = apiURLs.TransactionManagement.GetAllReceiving;
        return this.httpService.postHttpRequest(requisitionRequestUrl, RequisitionRequestPayload);
    }

    /**
     * Delete saved invoices
     * @param invoiceIds - Array of invoice IDs to delete
     * @returns Observable of the delete response
     */
    deleteSavedInvoices(invoiceIds: number[]): Observable<any> {
        const deleteUrl = APIENDPOINTURL.ReceivingApi.DeleteSavedInvoice;
        return this.httpService.postHttpRequest(deleteUrl, invoiceIds);
    }
}
